/**
 * Utility functions for onboarding functionality
 */

import { OnboardingStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import { MRT_ColumnFiltersState } from "mantine-react-table";

/**
 * Converts string to title case
 */
export const toTitleCase = (str: unknown): string => {
  if (typeof str !== "string" || str == null) {
    return "";
  }
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Checks if onboarding status is editable
 */
export const isEditableStatus = (status: OnboardingStatusEnum): boolean => {
  return (
    status === OnboardingStatusEnum.ONBOARDING_IN_DRAFT ||
    status === OnboardingStatusEnum.ONBOARDING_RESUBMISSION_IN_DRAFT
  );
};

/**
 * Transforms Mantine column filters to API format
 */
export const transformColumnFilters = (
  columnFilters: MRT_ColumnFiltersState
): string => {
  return JSON.stringify(
    columnFilters.reduce((acc, filter) => {
      if (filter.id && filter.value !== undefined) {
        acc[filter.id] = filter.value;
      }
      return acc;
    }, {} as Record<string, unknown>)
  );
};
